import { render, staticRenderFns } from "./ProductSelectionProtection.vue?vue&type=template&id=9c2f9270&lang=html&"
import script from "./ProductSelectionProtection.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports